<template>
  <div>
    <div class="columns">
      <div class="column is-4-tablet is-3-desktop">
        <o-field>
          <o-input type="search" placeholder="Search" icon="search" v-model="searchTerm"
            @input="handleOnSearch"></o-input>
        </o-field>
      </div>
      <div class="column">
        <div class="field is-grouped is-pulled-right">
          <p v-if="isDeleteSelectedButtonVisible" class="control">
            <a @click.prevent="handleRemove" class="button is-danger">Delete selected</a>
          </p>
          <p class="control">
            <uploadcare @update:modelValue="handleUploads" format="object" :multiple="true" ref="ucare" />
          </p>
        </div>
      </div>
    </div>

    <o-table :class="referenceType == 'project' ? 'project-width-table' : 'fullwidth-table'"
      class="is-responsive is-responsive-wide" :data="filteredFiles" :bordered="table.bordered" :striped="table.striped"
      :narrowed="table.narrowed" :checkable="table.checkable" :loading="table.loading"
      :mobile-cards="table.hasMobileCards" :paginated="table.paginated" :per-page="table.perPage"
      :pagination-simple="table.paginationSimple" v-model:selected="selected" :default-sort="['created_at', 'desc']"
      :checked-rows="checkedRows" @update:checkedRows="$event => checkedRows = $event">
      <template>
        <o-table-column #default="{ row }" field="name" label="Name" sortable>
          <content-editable :entity="row" field="name" :update="partialUpdateFile" />
        </o-table-column>

        <o-table-column #default="{ row }" field="size" label="Size" sortable>
          {{ $filters.readableSize(row.size) }}
        </o-table-column>

        <o-table-column #default="{ row }" field="user_id" label="Uploaded By" sortable>
          <router-link :to="{ name: 'users.show', params: { slug: row.user_id } }">
            {{ userNameById(row.user_id) }}
          </router-link>
        </o-table-column>

        <o-table-column #default="{ row }" field="created_at" label="Created At" sortable>
          {{ $filters.datetime(row.created_at) }}
        </o-table-column>

        <o-table-column #default="{ row }" label="">
          <!-- <a @click.stop.prevent="createTransmittal" class="button is-dark is-small">Create transmittal</a> -->
          <o-dropdown hoverable position="bottom-left" class="table-actions">
            <template #trigger>
              <button class="button">
                <o-icon pack="fa" icon="ellipsis-v"></o-icon>
              </button>
            </template>
            <o-dropdown-item has-link><a :href="`${row.path}-/inline/no/`" download>Download</a></o-dropdown-item>
            <o-dropdown-item has-link><a @click.prevent.stop="openPreviewModal(row)">Preview</a></o-dropdown-item>
          </o-dropdown>
        </o-table-column>
      </template>

      <template #empty>
        <div class="has-text-centered">
          No files are uploaded yet
        </div>
      </template>
    </o-table>

    <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isPreviewModalActive"
      class="preview-modal" has-modal-card>
      <preview-modal :file="currentPreviewFile" />
    </o-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { get_names_and_count } from "../modules/emails/gmail_api";
import Table from './../mixins/Table';
import Uploadcare from './Uploadcare';
import PreviewModal from './modals/Preview';

export default {
  props: ['referenceId', 'referenceType'],

  mixins: [Table],

  components: {
    Uploadcare,
    PreviewModal
  },

  computed: {
    ...mapGetters(['userNameById', 'filesByReference', 'notesByReference']),

    files() {
      const data = []
      const files = []
      this.messages.forEach(message => {
        if (message.thread_id === message.message_id) {
          data.push(message)
        }
      })
      this.messages.forEach(message => {
        if (message.thread_id !== message.message_id) {
          data.forEach(thread => {
            if (message.thread_id === thread.thread_id) {
              thread.messages = thread.messages || []
              thread.messages.push(message)
            }
          })
        }
      })

      data.map(value => {
        if (value.files.length !== 0) {
          value.files.map(value1 => {
            if (value1.reference_type !==  'email') {
              files.push(value1)
            }
          })
        }
      })

      const notes = this.notesByReference(this.referenceType, this.referenceId)
      let notesFiles = notes.reduce((a, n) => {
        this.filesByReference('note', n.id).forEach(f => {
          a.push(f)
        }); return a
      }, [])
      let filesObject = {};
      [...this.filesByReference(this.referenceType, this.referenceId), ...notesFiles, ...files, ...this.changeOrdersPdf].forEach(f => {
        filesObject[f.id] = filesObject[f.id] || f
      })
      // setTimeout(() => console.log([...this.filesByReference(this.referenceType, this.referenceId)]), 2000)
      return Object.keys(filesObject).map(k => filesObject[k])
    },

    isDeleteSelectedButtonVisible() {
      return this.checkedRows.length
    },

    threads() {
      const threads = []
      this.messages.forEach(message => {
        if (message.thread_id === message.message_id) {
          threads.push(message)
        }
      })
      this.messages.forEach(message => {
        if (message.thread_id !== message.message_id) {
          threads.forEach(thread => {
            if (message.thread_id === thread.thread_id) {
              thread.messages = thread.messages || []
              thread.messages.push(message)
            }
          })
        }
      })
      threads.forEach(thread => {
        thread.messages = thread.messages || []
        const { count, from_array } = get_names_and_count([thread, ...thread.messages])
        thread.from_array = from_array
        thread.from_names_count = count
      })
      return threads
    }
  },

  data() {
    return {
      currentPreviewFile: null,
      filteredFiles: [],
      isPreviewModalActive: false,
      searchTerm: '',
      messages: [],
      final_values: [],
      filename_removed: [],
      uniqueChars: [],
      changeOrdersPdf: []
    }
  },

  _methods: {
    ...mapActions({
      createFile: 'createFile',
      removeFile: 'removeFile',
      partialUpdateFile: 'partialUpdateFile',
      fetchEmails: "fetchEmails",
      fetchChangeOrders: "fetchChangeOrders"
    }),

    filterFiles() {
      if (this.searchTerm) {
        setTimeout(() => {
          this.filteredFiles = this.uniqueChars.filter(file => new RegExp(`.*${this.searchTerm}.*`, 'gi').test(file.name));
        }, 2100);
      } else {
        setTimeout(() => this.filteredFiles = this.uniqueChars, 2100);
      }
    },

    init() {
      const reference_id = parseInt(this.$route.params.slug);
      const reference_type = this.$route.name === 'projects.show.documents' ? 'project' : 'proposal';
      if (reference_id && reference_type) {
        this.fetchEmails({ reference_id, reference_type, withFiles: true }).then(data => {
          const { messages } = data;
          this.messages = messages;
        });
      }

      this.filterFiles()
      const uniqueIds = new Set();

      // setTimeout(() => {
      //   this.messages.map(value => {
      //     if (value.payload.parts) {
      //       value.payload.parts.map((val) => {
      //         val.headers.map(header => {
      //           if (header.name === "Content-Disposition") {
      //             if (/(attachment|inline);\s*filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/g.test(header.value)) {
      //               let content = /(attachment|inline);\s*filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/g.exec(header.value)["1"]
      //               let filename = /(attachment|inline);\s*filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/g.exec(header.value)["2"]
      //               if (content !== "inline") {
      //                 this.files
      //                   .filter(x => x.name == filename)
      //                   .map((file) => {
      //                     this.final_values.push(file)
      //                   })
      //               }
      //             }
      //           }
      //         })
      //       })
      //     }
      //   })
      // }, 1400)

      setTimeout(() => {

        const unique = this.files.filter(element => {
          const isDuplicate = uniqueIds.has(element.mime.includes("image/") ? element.uuid : null);
          // const isDuplicate2 = uniqueIds.has(element.mime.includes("image/"));

          uniqueIds.add(element.uuid);
          // uniqueIds.add(!element.mime.includes("image/"))

          if (!isDuplicate) {
            return true;
          }

          return false;
        });

        this.uniqueChars = unique
      }, 2000)

      if (this.referenceId) {
        this.fetchChangeOrders({ project_id: this.referenceId })
          .then(changeOrder => {

            changeOrder.data.data.map(value => {
              if (value.status === "approved") {
                this.changeOrdersPdf.push({
                  id: value.id,
                  user_id: value.created_by,
                  uuid: value.uuid || this.uuidGenerator(),
                  reference_type: "change_order",
                  reference_id: value.id,
                  path: `${window.location.origin}/change-orders/${value.id}/pdf`,
                  name: `Change Order ${value.id}.pdf`,
                  mime: "application/pdf",
                  size: 45000,
                  hash: value.hash || this.hashGenerator(),
                  created_at: value.created_at,
                  updated_at: value.updated_at,
                  project_id: null,
                  deleted_id: null,
                  generatedOnTheFly: true
                })
              }
            })

          })
      }

      if(this.referenceType === 'project' && this.referenceId) {
        const port = window.location.port ? `:${window.location.port}` : '';
        this.changeOrdersPdf.push({
          id: this.referenceId + this.referenceId,
          user_id: this.currentUserId,
          uuid: this.uuidGenerator(),
          reference_type: "project",
          reference_id: this.referenceId,
          name: `Proposal #${this.referenceId}`,
          mime: 'application/pdf',
          path: `${window.location.protocol}//${window.location.hostname}${port}/proposals/${this.referenceId}/pdf`,
          size: 45000,
          hash: this.hashGenerator(),
          created_at: new Date(),
          updated_at: new Date(),
          project_id: null,
          deleted_id: null,
          generatedOnTheFly: true
        })
        
      }
    },

    handleOnSearch: _.debounce(function () { this.filterFiles(); }, 250),

    handleRemove() {
      this.confirmMessageHtml(
        'Deleting Files',
        'Are you sure you want to <strong>delete</strong> selected files? This action cannot be undone.',
        'Delete Files'
      ).then(() => {
        let promises = [];

        _.each(this.checkedRows, row => {
          let promise = this.removeFile(row);
          promises.push(promise);
        });

        Promise.all(promises).then(() => {
          this.successMessage('Files have been deleted');
          this.init();
          this.clearCheckedRows();
        });
      });
    },

    handleUploads(files) {
      if (!files) return;

      if (!Array.isArray(files)) {
        files = [files];
      }

      let promises = [];

      files.forEach((file) => {
        let promise = this.createFile({
          user_id: this.currentUserId,
          uuid: file.uuid,
          path: file.cdnUrl,
          name: file.name,
          mime: file.mimeType,
          size: file.size,
          reference_id: this.referenceId,
          reference_type: this.referenceType
        });
        promises.push(promise);
      });


      if (promises.length) {
        Promise.all(promises).then(() => {
          this.$refs.ucare.clear()
          this.init()
        })
      }
    },

    openPreviewModal(file) {
      this.isPreviewModalActive = true;
      this.currentPreviewFile = file;
    },

    uuidGenerator() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

    hashGenerator() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },

  mounted() {
    this.init()

  },

  watch: {
    files() {
      this.filterFiles()
    }
  }
}
</script>
